import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./PremiumRefundTC.css";
import { useHeader } from "../../../../context/HeaderContext";

const PremiumRefundTC = () => {
    const location = useLocation();
    const initialTab = location.state?.tab || "premium";
    // Premium Plus is hidden as a product (Aug 2026): force 'premium'
    const effectiveTab = initialTab === "premiumPlus" ? "premium" : initialTab;
    const { setScreenName } = useHeader();

    const [selectedPlan, setSelectedPlan] = useState(effectiveTab);

    useEffect(() => {
        setScreenName("Refund Policy");
        return () => {
            setScreenName(null);
        };
    }, []);

    return (
        <div className="tpu__dashboard__wrapper layoutContainer">
            <div className="premium-safe-area">
                <div className="premium-upgrade-section">

                    {selectedPlan === "premium" && (

                        <div>

                            <div className="premium-policy-title">
                                TaskPlanet – Premium Refund Policy (14-Day Money-Back Guarantee)
                            </div>

                            <div className="premium-policy-meta">
                                Last Updated: 6 Feb 2026.
                            </div>

                            <div className="premium-policy-text">
                                At TaskPlanet, Premium membership is designed to help you unlock higher rewards, exclusive tasks, and faster growth. We strongly encourage users to spend time exploring all Premium features before requesting a refund—many users find value after continued usage.
                            </div>

                            <div className="premium-policy-text">
                                That said, if Premium does not meet your expectations, TaskPlanet offers a 14-Day Money-Back Guarantee, subject to the terms below.
                            </div>

                            <div className="premium-section-title">
                                1. Refund Eligibility (14 Days)
                            </div>

                            <div className="premium-policy-text">
                                Refund requests can be made within 14 days from the Premium purchase date.
                            </div>

                            <div className="premium-policy-text">
                                After refund approval, your account will be converted back to a Free Account.
                            </div>

                            <div className="premium-policy-text">
                                All Premium features and benefits will be disabled immediately.
                            </div>

                            <div className="premium-section-title">
                                2. Non-Eligible Refund Cases
                            </div>

                            <div className="premium-policy-text">
                                A refund request will be rejected if:
                            </div>

                            <div className="premium-policy-text">
                                ❌ Any withdrawal has been made after upgrading to Premium
                            </div>

                            <div className="premium-policy-text">
                                ❌ The request violates TaskPlanet policies or involves misuse of rewards
                            </div>

                            <div className="premium-section-title">
                                3. Mandatory Support Call
                            </div>

                            <div className="premium-policy-text">
                                A mandatory verification call is required before applying for a refund.
                            </div>

                            <div className="premium-policy-text">
                                This helps us understand concerns and confirm refund eligibility.
                            </div>

                            <div className="premium-policy-text">
                                Refund requests without call verification will not be processed.
                            </div>

                            <div className="premium-section-title">
                                4. Refund Deduction Policy (Important)
                            </div>

                            <div className="premium-policy-text">
                                TaskPlanet does NOT deduct any bonus points, rewards, or benefits individually.
                            </div>

                            <div className="premium-policy-text">
                                Instead, a fixed amount equivalent to the membership package value (in points/reward value) will be deducted as per cancellation rules.
                            </div>

                            <div className="premium-policy-text">
                                This deduction covers:
                            </div>

                            <div className="premium-policy-text">
                                • Bonus points granted at the time of purchase
                            </div>

                            <div className="premium-policy-text">
                                • Any extra rewards earned due to Premium access
                            </div>

                            <div className="premium-policy-text">
                                • All referral income credited to uplines because of your Premium purchase will be deducted
                            </div>

                            <div className="premium-policy-text">
                                No individual points or benefits will be removed from the user account; only the membership-equivalent deduction amount will be applied.
                            </div>

                            <div className="premium-section-title">
                                5. Refund Application Process
                            </div>

                            <div className="premium-policy-text">
                                To request a refund:
                            </div>

                            <div className="premium-policy-text">
                                Email{" "}
                                <a
                                    href="mailto:support@taskplanet.org"
                                    className="premium-link"
                                >
                                    support@taskplanet.org
                                </a>
                            </div>

                            <div className="premium-policy-text">
                                Attach:
                            </div>

                            <div className="premium-policy-text">
                                • Payment screenshot / transaction proof
                            </div>

                            <div className="premium-policy-text">
                                • Premium purchase history
                            </div>

                            <div className="premium-policy-text">
                                • Registered account details
                            </div>

                            <div className="premium-policy-text">
                                Requests must be sent from the registered email ID.
                            </div>

                            <div className="premium-section-title">
                                6. Refund Processing Timeline
                            </div>

                            <div className="premium-policy-text">
                                Approved refunds will be processed within 5–10 business days.
                            </div>

                            <div className="premium-policy-text">
                                The refundable amount (after applicable deduction) will be credited to the original payment method.
                            </div>

                            <div className="premium-section-title">
                                7. Policy Rights
                            </div>

                            <div className="premium-policy-text">
                                TaskPlanet reserves the right to approve or deny refund requests after review.
                            </div>

                            <div className="premium-policy-text">
                                Abuse of the refund policy may result in account limitations.
                            </div>

                            <div className="premium-policy-text">
                                This policy is subject to change without prior notice.
                            </div>

                        </div>

                    )}


                    {selectedPlan === "premiumPlus" && (

                        <div>

                            <div className="premium-policy-title">
                                TaskPlanet – Premium Plus Refund Policy (14-Day Money-Back Guarantee)
                            </div>

                            <div className="premium-policy-meta">
                                Last Updated: 6 Feb 2026.
                            </div>

                            <div className="premium-policy-text">
                                At TaskPlanet, Premium Plus membership is designed to help you unlock higher rewards, exclusive tasks, and faster growth. We strongly encourage users to spend time exploring all Premium Plus features before requesting a refund—many users find value after continued usage.
                            </div>

                            <div className="premium-policy-text">
                                That said, if Premium Plus does not meet your expectations, TaskPlanet offers a 14-Day Money-Back Guarantee, subject to the terms below.
                            </div>

                            <div className="premium-section-title">
                                1. Refund Eligibility (14 Days)
                            </div>

                            <div className="premium-policy-text">
                                Refund requests can be made within 14 days from the Premium Plus purchase date.
                            </div>

                            <div className="premium-policy-text">
                                After refund approval, your account will be converted back to a Free Account.
                            </div>

                            <div className="premium-policy-text">
                                All Premium Plus features and benefits will be disabled immediately.
                            </div>

                            <div className="premium-section-title">
                                2. Non-Eligible Refund Cases
                            </div>

                            <div className="premium-policy-text">
                                A refund request will be rejected if:
                            </div>

                            <div className="premium-policy-text">
                                ❌ Any withdrawal has been made after upgrading to Premium Plus
                            </div>

                            <div className="premium-policy-text">
                                ❌ The request violates TaskPlanet policies or involves misuse of rewards
                            </div>

                            <div className="premium-section-title">
                                3. Mandatory Support Call
                            </div>

                            <div className="premium-policy-text">
                                A mandatory verification call is required before applying for a refund.
                            </div>

                            <div className="premium-policy-text">
                                This helps us understand concerns and confirm refund eligibility.
                            </div>

                            <div className="premium-policy-text">
                                Refund requests without call verification will not be processed.
                            </div>

                            <div className="premium-section-title">
                                4. Refund Deduction Policy (Important)
                            </div>

                            <div className="premium-policy-text">
                                TaskPlanet does NOT deduct any bonus points, rewards, or benefits individually.
                            </div>

                            <div className="premium-policy-text">
                                Instead, a fixed amount equivalent to the membership package value (in points/reward value) will be deducted as per cancellation rules.
                            </div>

                            <div className="premium-policy-text">
                                This deduction covers:
                            </div>

                            <div className="premium-policy-text">
                                • Bonus points granted at the time of purchase
                            </div>

                            <div className="premium-policy-text">
                                • Any extra rewards earned due to Premium Plus access
                            </div>

                            <div className="premium-policy-text">
                                • All referral income credited to uplines because of your Premium Plus purchase will be deducted
                            </div>

                            <div className="premium-policy-text">
                                No individual points or benefits will be removed from the user account; only the membership-equivalent deduction amount will be applied.
                            </div>

                            <div className="premium-section-title">
                                5. Refund Application Process
                            </div>

                            <div className="premium-policy-text">
                                To request a refund:
                            </div>

                            <div className="premium-policy-text">
                                Email{" "}
                                <a
                                    href="mailto:support@taskplanet.org"
                                    className="premium-link"
                                >
                                    support@taskplanet.org
                                </a>
                            </div>

                            <div className="premium-policy-text">
                                Attach:
                            </div>

                            <div className="premium-policy-text">
                                • Payment screenshot / transaction proof
                            </div>

                            <div className="premium-policy-text">
                                • Premium Plus purchase history
                            </div>

                            <div className="premium-policy-text">
                                • Registered account details
                            </div>

                            <div className="premium-policy-text">
                                Requests must be sent from the registered email ID.
                            </div>

                            <div className="premium-section-title">
                                6. Refund Processing Timeline
                            </div>

                            <div className="premium-policy-text">
                                Approved refunds will be processed within 5–10 business days.
                            </div>

                            <div className="premium-policy-text">
                                The refundable amount (after applicable deduction) will be credited to the original payment method.
                            </div>

                            <div className="premium-section-title">
                                7. Policy Rights
                            </div>

                            <div className="premium-policy-text">
                                TaskPlanet reserves the right to approve or deny refund requests after review.
                            </div>

                            <div className="premium-policy-text">
                                Abuse of the refund policy may result in account limitations.
                            </div>

                            <div className="premium-policy-text">
                                This policy is subject to change without prior notice.
                            </div>

                        </div>

                    )}

                </div>
            </div>
        </div>
    );
};

export default PremiumRefundTC;